import { Link } from '@tanstack/react-router';
import { buttonClasses } from '../ui/Button.js';
import { PublicShell } from './PublicShell.js';

const HOME = buttonClasses({ variant: 'primary', size: 'lg', block: true });

/** Page introuvable (adresse inconnue) : portail de la plateforme, sans marque. */
export function NotFoundPage() {
  return (
    <PublicShell title="Page introuvable" intro="Cette adresse n’existe pas ou n’est plus disponible. Vérifiez le lien, ou repartez de l’accueil.">
      <Link to="/" className={HOME}>
        Revenir à l’accueil
      </Link>
    </PublicShell>
  );
}

/** Garage introuvable : même texte pour un slug inconnu, d'un autre garage ou suspendu (aucune énumération). */
export function GarageNotFound() {
  return (
    <PublicShell title="Garage introuvable" intro="Cette adresse ne correspond à aucun garage accessible avec votre compte.">
      <Link to="/" className={HOME}>
        Revenir à l’accueil
      </Link>
    </PublicShell>
  );
}
